// Google AdSense (web) — flag-gated, SFW-only, and consent-gated.
// Nothing loads unless:
//   1. REACT_APP_ADS_ENABLED === "true" and a valid ca-pub- client id is set
//   2. The current route is in the allowed (SFW) list
//   3. The user has given cookie consent (nox_cookie_consent === "accepted")
// NSFW/studio routes never render ad units.

const CLIENT_RE = /^ca-pub-\d+$/;
export const CONSENT_KEY = "nox_cookie_consent";

export const ADS_CLIENT = process.env.REACT_APP_ADS_CLIENT || "";
export const adsEnabled =
  process.env.REACT_APP_ADS_ENABLED === "true" && CLIENT_RE.test(ADS_CLIENT);

// Default-deny: only these public/SFW route prefixes may show ads.
const ALLOWED_PREFIXES = [
  "/", "/blog", "/pricing", "/contact", "/use-cases",
  "/privacy-policy", "/terms", "/about",
];
const BLOCKED_PREFIXES = [
  "/studio", "/editor", "/dashboard", "/admin", "/gallery",
  "/brand", "/campaigns", "/uncensored", "/nsfw", "/adult",
];

export function isAdsAllowedPath(pathname = window.location.pathname) {
  if (BLOCKED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) return false;
  return ALLOWED_PREFIXES.some((p) => (p === "/" ? pathname === "/" : pathname.startsWith(p)));
}

export function getCookieConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function loadAdSenseOnce() {
  if (!adsEnabled || !isAdsAllowedPath()) return;
  // Do not load until the user has explicitly accepted cookies
  if (getCookieConsent() !== "accepted") return;
  if (document.querySelector('script[data-adsense-loader="true"]')) return;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.dataset.adsenseLoader = "true";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(ADS_CLIENT)}`;
  document.head.appendChild(s);
}

export function pushAd(ins) {
  if (!ins || ins.dataset.adPushed === "true") return;
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
    ins.dataset.adPushed = "true";
  } catch (e) {
    // never retry the same <ins> — duplicate pushes throw
  }
}
